import * as React from 'react';
import * as styles from './styles.css';
import cn from 'clsx';

/**
 * @todo move from deprecated typography to new one
 * @see {@link https://jira.cian.tech/browse/CD-163108}
 */
import { Header0, UIText1 } from '@cian/ui-kit/typography';

import { NBSP } from '../../../../constants/symbols';

export interface IAsideProps {
  backToPage: React.ReactNode;
  withSaleRentIntro?: boolean;
}

export function Aside({ backToPage, withSaleRentIntro }: IAsideProps) {
  return (
    <>
      {backToPage}
      <h1 className={cn(styles['title'], { [styles['title-sale-rent']]: withSaleRentIntro })}>
        <Header0>{withSaleRentIntro ? 'Куплю/Сниму на Циан' : 'Заявка риелтору'}</Header0>
      </h1>
      <div className={styles['description']}>
        <UIText1>
          Информация из этой анкеты поможет подходящему риелтору найти вашу заявку и{NBSP}обработать её. Комиссия
          за услуги обсуждается с риелтором
        </UIText1>
      </div>
      <div className={cn(styles['img'], { [styles['img-sale-rent']]: withSaleRentIntro })} />
    </>
  );
}
